module.exports = __webpack_public_path__ + "static/media/2.d5bfe5d2.jpg";